/** 僅保留本次表單於記憶體；同意圖重試保留 key，未知結果不允許換內容再送。 */
export function legacyExternalRequestKeys(generate: () => string) {
 let signature = ''; let key = ''; let replaceAllowed = false;
 const clear = () => { signature = ''; key = ''; replaceAllowed = false; };
 return { forRequest(payload: unknown) { const next = JSON.stringify(payload); if (key && next !== signature && !replaceAllowed) throw new Error('legacy_external_pending_request'); if (!key || next !== signature) { signature = next; key = generate(); replaceAllowed = false; } return key; }, completed: clear, rejected() { replaceAllowed = true; } };
}
